import React, { useState } from 'react';
import { FileUpload } from './FileUpload';

export function FileUploadExample({ description }: { description?: string }): JSX.Element {
  const [image, setImage] = useState<string | undefined>(undefined);

  function handleImageChange(file: File[]): void {
    if (file.length <= 0) {
      return setImage(undefined);
    }
    const reader = new FileReader();

    reader.readAsDataURL(file[0]);

    reader.onload = () => {
      if (reader.result && typeof reader.result === 'string') {
        setImage(reader.result);
      }
    };
  }

  return (
    <>
      <FileUpload
        onChange={handleImageChange}
        image={image}
        label="This is the label of the File Upload"
        description={description}
        icon="activity"
      />
    </>
  );
}
